<template>
  <div class="main-container">
    <v-app v-if="showImport">
      <component :is="$route.meta.layout || 'DefaultLayout'">
        <template v-slot:content>
          <router-view />
        </template>
      </component>
    </v-app>
    <router-view v-if="showShare" />
  </div>
</template>

<script>
import DefaultLayout from "./layout/default";
import { set_auth_cookie } from "./helpers/auth";

export default {
  name: "App",
  components: {
    DefaultLayout,
  },
  computed: {
    showImport() {
      return this.$route.path.includes("/import");
    },
    showShare() {
      return this.$route.path.includes("/");
    },
  },
  beforeCreate() {
    let token = this.$route.query.token;
    let path = this.$route.path;

    if (token) set_auth_cookie(token);

    this.$store.dispatch("auth/checkAuthenticated");
    let authenticated = this.$store.state.auth.authenticated;

    if (authenticated) {
      let legitPath = path.includes("/import") || path.includes("/m") || path.includes("/z") || path.includes("/x");
      if (!legitPath) {
        this.$router.push("/import");
      }
    }
  },
};
</script>

<style >
.main-container {
  padding: 0;
  margin: 0;
}
</style>

<style lang="scss">
@font-face {
  font-family: "SF UI Text Regular";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Regular"),
    url("~@/assets/fonts/sf-ui/SFUIText-Regular.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Italic";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Italic"),
    url("~@/assets/fonts/sf-ui/SFUIText-RegularItalic.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Light";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Light"),
    url("~@/assets/fonts/sf-ui/SFUIText-Light.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Light Italic";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Light Italic"),
    url("~@/assets/fonts/sf-ui/SFUIText-LightItalic.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Medium";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Medium"),
    url("~@/assets/fonts/sf-ui/SFUIText-Medium.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Medium Italic";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Medium Italic"),
    url("~@/assets/fonts/sf-ui/SFUIText-MediumItalic.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Semibold";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Semibold"),
    url("~@/assets/fonts/sf-ui/SFUIText-Semibold.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Semibold Italic";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Semibold Italic"),
    url("~@/assets/fonts/sf-ui/SFUIText-SemiboldItalic.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Bold";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Bold"),
    url("~@/assets/fonts/sf-ui/SFUIText-Bold.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Bold Italic";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Bold Italic"),
    url("~@/assets/fonts/sf-ui/SFUIText-BoldItalic.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Heavy";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Heavy"),
    url("~@/assets/fonts/sf-ui/SFUIText-Heavy.woff") format("woff");
}

@font-face {
  font-family: "SF UI Text Heavy Italic";
  font-style: normal;
  font-weight: normal;
  src: local("SF UI Text Heavy Italic"),
    url("~@/assets/fonts/sf-ui/SFUIText-HeavyItalic.woff") format("woff");
}
.v-application {
  font-family: "SF UI Text Regular";
}
</style>